import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_SkillEditor = _resolveComponent("SkillEditor")
  const _component_SplitterPanel = _resolveComponent("SplitterPanel")
  const _component_SkillsList = _resolveComponent("SkillsList")
  const _component_Splitter = _resolveComponent("Splitter")
  const _component_SettingsFrame = _resolveComponent("SettingsFrame")

  return (_openBlock(), _createBlock(_component_SettingsFrame, { class: "skills-frame" }, {
    default: _withCtx(() => [
      (!$data.skills)
        ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("Loading test skills...")
            ])),
            _: 1 /* STABLE */
          }))
        : (_openBlock(), _createBlock(_component_Splitter, {
            key: 1,
            class: "skills-panel",
            unstyled: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SplitterPanel, {
                class: "editor-panel",
                unstyled: false,
                size: 50,
                "min-size": 20
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SkillEditor, {
                    ref: "editor",
                    "vread-from": "editing_idx",
                    "onUpdate:editing_idx": $event => (($data.editing_idx) = $event),
                    "limit-reached": $options.limit_reached,
                    agents: $data.agents,
                    onAdd: $options.createSkill,
                    onSave: $options.saveSkill
                  }, null, 8 /* PROPS */, ["onUpdate:editing_idx", "limit-reached", "agents", "onAdd", "onSave"])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_SplitterPanel, {
                class: "list-panel",
                unstyled: false,
                size: 50,
                "min-size": 20
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SkillsList, {
                    skills: $data.skills,
                    "selected-idx": $data.editing_idx,
                    saving: $data.saving,
                    saved_at: $data.saved_at,
                    onEdit: _cache[0] || (_cache[0] = $event => (_ctx.$refs.editor.edit($data.skills[$event], $event))),
                    onDelete: $options.deleteSkill
                  }, null, 8 /* PROPS */, ["skills", "selected-idx", "saving", "saved_at", "onDelete"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }))
    ]),
    _: 1 /* STABLE */
  }))
}